/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import withPageErrorBoundary from '@ion/applications/src/pages/withPageErrorBoundary';
import {useAssetState} from '@/routes/tracking/hooks/tracking/useAssetState';
import {reInitializeTracking} from '../../../store/actions/tracking';
import SidesheetContent from './SidesheetContent';

/**
 * @MobileSideSheetContent
 * Returns component for rendering breadcrumbs, panel list, details and associated tag details for mobile.
 * 
 *  ```typescript
 *   import MobileSideSheetContent from '@/routes/tracking/sidesheet/MobileSideSheetContent';
 * 
 *   <MobileSideSheetContent />
 *  ```
 */
const MobileSideSheetContent = () => {
  const assetList = useAssetState();
  
  return (
    <SidesheetContent assetList={assetList}/>
  );
};

export default withPageErrorBoundary(React.memo(MobileSideSheetContent), {
  onErrorRecoveryAction : reInitializeTracking
});
